import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Modal } from 'ui/Modal';

import { useLazyFetchProfileQuery, useSetSignOutMutation } from '../../services/modules/user';
import { Button, Header } from '../../ui';

import {
  Content,
  ErrorBodyWrapper,
  ErrorButtons,
  FullName,
  FullNameSkeleton,
  JobDescription,
  Logout,
  LogoutText,
  MobileNumber,
  MobileNumberSkeleton,
  StarRate,
  UserCard,
  UserContent,
  UserImage,
  UserImageSkeleton,
} from './ProfileElements';

export const Profile = () => {
  const { t } = useTranslation();
  const [fetchProfile, { data, isLoading }] = useLazyFetchProfileQuery();
  const [open, setOpen] = useState<boolean>(false);

  const [setSignOut] = useSetSignOutMutation();

  useEffect(() => {
    fetchProfile();
  }, []);
  const logoutHandler = async () => {
    localStorage.getItem('fcm_token') &&
      (await setSignOut({
        fcm_token: localStorage.getItem('fcm_token') as string,
      }));
    navigator.serviceWorker.ready.then((registration) => {
      registration.unregister();
    });
    localStorage.removeItem('token');
    localStorage.removeItem('fcm_token');
    window.location.replace('/');
  };
  const modalHandler = (state: boolean) => {
    setOpen(state);
  };
  return (
    <>
      <Header title={t('profile.profile')} />
      {isLoading && (
        <Content>
          <UserCard>
            <UserImageSkeleton />
            <UserContent>
              <FullNameSkeleton />
              <MobileNumberSkeleton />
              <MobileNumberSkeleton />
            </UserContent>
          </UserCard>
        </Content>
      )}
      <Content>
        {data && (
          <UserCard>
            <UserImage>
              <label>{`${data?.first_name?.slice(0, 1)}${data?.last_name?.slice(0, 1)}`}</label>
            </UserImage>
            <UserContent>
              <FullName>{`${data?.first_name} ${data?.last_name}`}</FullName>
              <JobDescription>{t('profile.expert_inspector')}</JobDescription>
              <MobileNumber>{data?.mobile}</MobileNumber>
            </UserContent>
            <StarRate>
              {5}
              <span className={'icon-u_star'} />
            </StarRate>
          </UserCard>
        )}
        <Logout>
          <Button onClick={() => modalHandler(true)} color="red" fullWidth>
            {t('profile.logout')}
          </Button>
        </Logout>
        <Modal
          title={t('profile.are_you_sure')}
          onCloseModal={() => modalHandler(false)}
          isShow={open}
        >
          <ErrorBodyWrapper>
            <LogoutText>{t('profile.are_you_sure_you_want_to_exit')}</LogoutText>
          </ErrorBodyWrapper>
          <ErrorButtons>
            <Button fullWidth onClick={logoutHandler}>
              {t('profile.yes')}
            </Button>
            <Button fullWidth color="red" onClick={() => modalHandler(false)}>
              {t('profile.cancel')}
            </Button>
          </ErrorButtons>
        </Modal>
      </Content>
    </>
  );
};
